export enum RestaurantFinancialStatus {
    NOT_CONNECTED = "NOT_CONNECTED",
    ONBOARDING_REQUIRED = "ONBOARDING_REQUIRED",
    RESTRICTED = "RESTRICTED",
    ACTIVE = "ACTIVE"
}

export class RestaurantFinancialStatusResponse {
    public stripeAccountId: string = "";
    public currency: string = "";
    public availableBalanceCents: number = 0;
    public pendingBalanceCents: number = 0;
    public totalBalanceCents: number = 0;
    public hasNegativeBalance: boolean = false;
    public chargesEnabled: boolean = false;
    public payoutsEnabled: boolean = false;
    public detailsSubmitted: boolean = false;
    public financialStatus: RestaurantFinancialStatus = RestaurantFinancialStatus.NOT_CONNECTED;
    public currentlyDue: string[] = [];
    public pendingVerification: string[] = [];
    public disabledReason: string = "";
}
